"use strict";

var debug = require("debug")("knack.formatter.formatters.string");
var newLineRegex = new RegExp(/\n/, "g");

/**
 * @alias "formatters.string"
 * @param {Object} value
 * @return {String}
 */
var stringFormatter = function stringFormatter(value) {
  return String(value).replace(newLineRegex, "<br />");
};
module.exports = stringFormatter;